import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const UploadCircle = ({
  height = 24,
  width = 24,
  color = colors.grey50,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    fill="none"
    viewBox="0 0 20 20"
    className="shape"
    {...props}
  >
    <path
      d="M10.2871 4.80691C10.1987 4.77024 10.1017 4.75 10 4.75C9.89831 4.75 9.80134 4.77024 9.71291 4.80691C9.62445 4.84351 9.54158 4.89776 9.46967 4.96967L6.65717 7.78217C6.36428 8.07506 6.36428 8.54994 6.65717 8.84283C6.95006 9.13572 7.42494 9.13572 7.71783 8.84283L9.25 7.31066V13.9375C9.25 14.3517 9.58579 14.6875 10 14.6875C10.4142 14.6875 10.75 14.3517 10.75 13.9375V7.31066L12.2822 8.84283C12.5751 9.13572 13.0499 9.13572 13.3428 8.84283C13.6357 8.54994 13.6357 8.07506 13.3428 7.78217L10.5307 4.97007"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M10.2871 4.80691C10.3742 4.84293 10.4558 4.89606 10.5269 4.96629Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.3125C5.75431 2.3125 2.3125 5.75431 2.3125 10C2.3125 14.2457 5.75431 17.6875 10 17.6875C14.2457 17.6875 17.6875 14.2457 17.6875 10C17.6875 5.75431 14.2457 2.3125 10 2.3125ZM0.8125 10C0.8125 4.92588 4.92588 0.8125 10 0.8125C15.0741 0.8125 19.1875 4.92588 19.1875 10C19.1875 15.0741 15.0741 19.1875 10 19.1875C4.92588 19.1875 0.8125 15.0741 0.8125 10Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
